<!-- Chat Header -->
<div
  class="chat-header d-flex justify-content-between align-items-center bg-success text-white px-3 py-2"
>
  <h5 class="mb-0">Chat</h5>
  <button class="btn btn-sm btn-light" (click)="dismiss()" aria-label="Close">
    <i class="fas fa-times"></i>
  </button>
</div>

<!-- Chat Body -->
<div class="chat-content">
  <div class="chat-body">
    <ng-container *ngFor="let item of chatList">
      <!-- Only show date in header -->
      <div *ngIf="item.isHeader" class="chat-date-header">
        {{ item.timestamp | date : "mediumDate" }}
      </div>

      <!-- Chat message -->
      <div
        *ngIf="!item.isHeader"
        [ngClass]="item.isUser ? 'chat-message user' : 'chat-message other'"
      >
        <div class="chat-bubble">
          <div class="chat-text">{{ item.chat }}</div>
          <div class="chat-time">
            {{ item.timestamp | date : "shortTime" }}
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Scroll anchor -->
    <div #chatBottom></div>
  </div>
</div>

<!-- Chat Footer -->
<div class="chat-footer d-flex align-items-center px-3 py-2">
  <input
    type="text"
    [(ngModel)]="messageText"
    class="form-control chat-input"
    placeholder="Type a message..."
  />
  <button
    class="btn btn-success ms-2 chat-send"
    (click)="sendMessage()"
    [disabled]="!messageText.trim()"
  >
    <i class="fa fa-arrow-right"></i>
  </button>
</div>
